import React, { useState, useEffect, useRef } from "react";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";
// import { appLogo } from "../../../config/appConfig";
import Sidebar from "react-sidebar";
import SidebarContent from "../../../components/SidebarContent";
import {
  appDefaultOrg,
  appDashboardID,
  appProgramID,
  mapIndicatorsList,
} from "../../../config/appConfig.js";
import { Button } from "react-bootstrap";

const Header = ({onSuccess}) => {

  const [filterFlag, setFilterFlag] = useState(false);
  const [breadcrumbOrg, setBreadcrumbOrg] = useState();
  const [defaultOrg, setDefaultOrg] = useState([{ id: "", displayName: "" }]);
  const date = new Date();
  const [orgID, setOrgID] = useState(defaultOrg[0]);
  const navigate = useNavigate();
  const [currentPeriod, setCurrentPeriod] = useState(
    date.getFullYear().toString()
  );
  const [periodName, setPeriodName] = useState();

  const [isSidebarOpen, setSidebar] = useState(false);

  const handleLogout = () => {
    // console.log(":inside logout");
    sessionStorage.clear()
    sessionStorage.clear()
    // onSuccess()
    navigate("/");
    window.location.reload(false)
  };

  const onSetSidebarOpen = () => {
    if (isSidebarOpen === true) {
      setSidebar(false);
    } else {
      setSidebar(true);
    }
  };

  const closeSidebar = () => {
    setSidebar(false);
  };

  const applyFilter = (org, period,periodname,periodType) => {
    setFilterFlag(true);
    setBreadcrumbOrg(org);
    // setindicatorData([]);
    // setMapIndicatorData({});
    // setGeoJsonData({});
    setOrgID();
    
    setPeriodName(periodname)
    //setTimeout(function () {

    // console.log(org);
    setOrgID(org[org.length - 1].id);
    // console.log(period);
    setCurrentPeriod(period);

    closeSidebar();
    //}, 800);

    //setCurrentMapKey(currentMapKey + 1);
  };

  const resetFilter = () => {
    // setindicatorData([]);
    // setMapIndicatorData({});
    // setGeoJsonData({});
    // setCurrentPeriod(date.getFullYear().toString());
    // setPeriodName('')
    setOrgID(defaultOrg[0].id);
    setBreadcrumbOrg(defaultOrg);
    setFilterFlag(false);
    closeSidebar();
    //setCurrentMapKey(currentMapKey + 1);
  };

  useEffect(() => {
    // setLoading(true);
    // setLoadingChart(true);
    

    let count = 0;

    //console.log(breadcrumbOrg);

    if (!filterFlag) {
      if (
        JSON.parse(sessionStorage.getItem("userData")).organisationUnits.length >=
        1
      ) {
        setDefaultOrg(appDefaultOrg);
      } else {
        setDefaultOrg(
          JSON.parse(sessionStorage.getItem("userData")).organisationUnits
        );
      }

      // console.log(defaultOrg[0].id);
      setOrgID(defaultOrg[0].id);
      setBreadcrumbOrg(defaultOrg);
    }
  }, [orgID, currentPeriod,periodName]);

  return (
    <>
    {/*<Sidebar
        sidebar={
          <SidebarContent
            closeSidebar={closeSidebar}
            defaultOrg={defaultOrg}
            latestPeriod={currentPeriod}
            applyFilter={applyFilter}
            resetFilter={resetFilter}
          ></SidebarContent>
        }
        open={isSidebarOpen}
        onSetOpen={() => onSetSidebarOpen()}
        styles={{ sidebar: { background: "white", zIndex: 99999, } }}
        //docked="true"
        sidebarClassName="custom-sidebar-class"
        //contentId= "custom-sidebar-content-id"
        //open="false"
        touch={true}
        shadow={true}
        //pullRight="false"
        //touchHandleWidth="1000"
        //dragToggleDistance="30"
        transitions={true}
      >
         <b>Main content</b> 
      </Sidebar> */}
      <div className="app-header header-shadow">
        <div className="app-header__logo">
          <div className=""> 
          <h4>NCD E-Registry</h4>
            {/* <img src={appLogo} style={{ width: "150px" }} />  */}
          </div>
          <div className="header__pane ml-auto">
            <div>
              <button type="button" className="hamburger close-sidebar-btn hamburger--elastic" >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="app-header__mobile-menu">
          <div>
            <button type="button" className="hamburger hamburger--elastic mobile-toggle-nav">
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
        <div className="app-header__menu">
          <span>
            <button type="button" className="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
              <span className="btn-icon-wrapper">
                <i className="fa fa-ellipsis-v fa-w-6"></i>
              </span>
            </button>
          </span>
        </div>
        <div className="app-header__content">
          <div className="app-header-right">
            <div className="header-btn-lg pr-0">
              <div className="widget-content p-0">
                <div className="widget-content-wrapper">
                  <div className="widget-content-left">
                    <div className="btn-group">
                      {/* <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="p-0 btn">
                          <img width="42" className="rounded-circle" src="assets/images/avatars/1.jpg" alt="" />
                          <i className="fa fa-angle-down ml-2 opacity-8"></i>
                        </a> */}
                      <div onClick={() => handleLogout()} className="d-flex font-style" style={{ "alignItems": "center" }}>
                        <span>Logout</span>
                        <FontAwesomeIcon className="p-2 m-auto logout btn-outline-light font-style" icon={faSignOut} />
                      </div>
                     {/* <div className="mr-2">
                <Button
                  variant="primary"
                  className="selectfilterbtn"
                  onClick={() => onSetSidebarOpen()}
                >
                  Select Filter <i className="fa fa-caret-down"></i>
                </Button>
              </div> */}
                      {/* <div tabindex="-1" role="menu" aria-hidden="true" className="dropdown-menu dropdown-menu-right">
                          <button type="button" tabindex="0" className="dropdown-item">Logout</button>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header